import { Alerta, TipoAlerta } from "@intechprev/componentes-web";
import React from "react";

export const AvisoLGPD: React.FC = () => {
  return (
    <>
      <Alerta tipo={TipoAlerta.warning} mensagem={"É proibida a reprodução das fotos aqui divulgadas, por questões de direito de imagem (LGPD), podendo ser utilizada somente para fins pessoais e com o objetivo eminentemente cultural."} />
    </>
  );
}